// extracted by mini-css-extract-plugin
export default {"body":"Estoques_body__cxAij","linksEstoques":"Estoques_linksEstoques__5k2G3"};